<template>
  <g>
    <rect
      id="dragRect"
      :x="50"
      :y="50"
      :width="50"
      :height="50"
      :stroke="'#546e7a'"
      :stroke-width="strokeWidth"
      :fill="'#546e7a'"
      :nodeIndex="1"
      :rx="borderRadius"
      opacity="0"
    />
    <rect
      id="dropRect"
      :x="150"
      :y="150"
      :width="50"
      :height="50"
      :stroke="'#546e7a'"
      :stroke-width="strokeWidth"
      :fill="'transparent'"
      :nodeIndex="1"
      :rx="borderRadius"
      opacity="0"
    />
    <circle
      id="dropCircle"
      :cx="unitPixel / 4"
      :cy="unitPixel / 4"
      :r="unitPixel / 3"
      :stroke-width="strokeWidth"
      :fill="'transparent'"
      :nodeIndex="1"
      opacity="0"
    />
    <circle
      id="dragCircle"
      :cx="unitPixel / 4"
      :cy="unitPixel / 4"
      :r="unitPixel / 3"
      :stroke-width="strokeWidth"
      :nodeIndex="1"
      opacity="0"
    />
  <svg
    id="addNodeCircle"
    :width="unitPixel"
    :height="unitPixel"
    :x="0"
    :y="0"
    fill="#363a48"
    opacity="0"
    >
      <circle
        class="dashed-circle"
        cx="50%"
        cy="50%"
        r="48%"
      />
      <circle
        class="solid-circle"
        cx="50%"
        cy="50%"
        r="40%"
      />
      <text
        class="circle__text"
        x="50%"
        y="50%"
        dominant-baseline="central"
        text-anchor="middle"
        pointer-events="none"
        fill="#ffffff"
        stroke="#ffffff"
      >
        +
      </text>
    </svg>
  </g>
</template>

<script>
export default {
  name: 'VDragAndDropFigures',
  props: {
    unitPixel: {
      type: Number
    }
  },
  data: () => (
    {
      borderRadius: 6,
      strokeWidth: 2
    }
  )
}
</script>



// WEBPACK FOOTER //
// src/components/VDragAndDropFigures.vue